/* OAF seating guide fallback (2026-10-30).
   1) Tables whose placeholder was not filled by oaf-table-guides.js (no per-product config) get a live guide.
   2) Inline seating guides on tables without a "Length" option (square/round tops sized by "Width",
      "Width / Length" or "Table Size") are computed here, because the inline guide needs Width + Length. */
(function () {
  'use strict';
  var EXT = {48:'4',54:'4–6',60:'4–6',66:'6',72:'6–8',78:'6–8',84:'8',90:'8',96:'8–10',102:'8–10',108:'10',114:'10',120:'10–12'};
  function clean(t) { return String(t || '').replace(/\s+/g, ' ').trim(); }
  function nums(t) { return (String(t).split(/\+|\$/)[0].match(/\d+(?:\.\d+)?/g) || []).map(Number); }
  function count(t) {
    if (!t || /solid|none|zero/i.test(t)) return 0;
    var w = {one:1,two:2,three:3,four:4,five:5,six:6};
    for (var k in w) if (new RegExp('\\b' + k + '\\b', 'i').test(t)) return w[k];
    var m = t.match(/^\s*(\d+)/); return m ? Number(m[1]) : 0;
  }
  function isRound(t) { return /\b(round|oval)\b/i.test(t || '') && !/square/i.test(t || ''); }
  function root() { return document.getElementById('itoris_dynamicproductoptions'); }
  function fields() {
    var r = root(); if (!r) return [];
    return Array.from(r.querySelectorAll('.field[id^="dynamic_option_id_"]')).filter(function (f) { return !f.closest('.ihidden'); });
  }
  function nameOf(f) { var l = f.querySelector(':scope > label'); return l ? clean(l.textContent).replace(/\s*\*\s*$/, '').toLowerCase() : ''; }
  function choice(f) {
    var s = f.querySelector('select'); if (s) return s.value ? clean(s.options[s.selectedIndex].textContent) : '';
    var c = f.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked'); if (!c) return '';
    var l = f.querySelector('label[for="' + CSS.escape(c.id) + '"]'); return clean(l ? l.textContent : '');
  }
  function read() {
    var o = {width: null, length: null, leaves: 0, hasLength: false, hasWidth: false, shapeText: '', sized: false};
    fields().forEach(function (f) {
      var n = nameOf(f), t = choice(f), v = nums(t);
      if (/^(width|diameter|round)$/.test(n)) { o.hasWidth = true; o.sized = true; o.width = v[0] || o.width; }
      else if (/^width\s*\/\s*length$/.test(n) || /^(table size|size|top size)$/.test(n)) { o.hasWidth = true; o.sized = true; o.width = v[0] || o.width; o.length = v[1] || o.length; if (isRound(t)) o.shapeText = t; }
      else if (n === 'length') { o.hasLength = true; o.sized = true; o.length = v[0] || o.length; }
      else if (/^(top shape|table shape|shape)$/.test(n)) { o.shapeText = o.shapeText || t; }
      if (/leaf|leaves/.test(n) && !/skirt|storage|self.?stor/.test(n)) {
        var k = count(t); var ex = (n + ' ' + t).match(/(\d+(?:\.\d+)?)\s*(?:["″]|inch)\s*(?:wide\s*)?(?:butterfly\s*)?lea(?:f|ves)/i);
        o.leaves += k * (ex ? Number(ex[1]) : 12);
      }
    });
    return o;
  }
  function shapeFor(o) {
    var s = (o.shapeText + ' ' + document.title).toLowerCase();
    if (isRound(o.shapeText)) return 'round';
    if (o.shapeText) return o.hasLength && o.length && o.length !== o.width ? 'rectangle' : 'square';
    return isRound(s) ? 'round' : 'square';
  }
  function compute(guide, matrix) {
    var o = read(), size = guide.querySelector('.oaf-seating-guide__size'), cap = guide.querySelector('.oaf-seating-guide__capacity');
    if (!size || !cap) return;
    function set(el, t) { if (el.textContent !== t) el.textContent = t; }
    if (!o.width) { set(size, 'Select your table size'); set(cap, 'Your finished size and seating estimate will update as you choose options.'); return; }
    var base = o.length || o.width, fin = base + o.leaves, shape = shapeFor(o), seats = '';
    if (matrix && matrix.length) { var m = matrix.find(function (x) { return Number(x.length_in) === fin; }); if (m) seats = String(m.seats); }
    if (!seats) {
      if (!o.leaves && shape === 'round') seats = o.width < 36 ? '2' : o.width <= 42 ? '4' : o.width <= 48 ? '4–6' : o.width <= 54 ? '6' : o.width <= 60 ? '6–8' : o.width <= 66 ? '8' : '8–10';
      else if (!o.leaves && base === o.width) seats = o.width <= 48 ? '4' : o.width <= 60 ? '6–8' : '8';
      else seats = EXT[fin] || (fin <= 50 ? '4' : fin <= 62 ? '4–6' : fin <= 68 ? '6' : fin <= 80 ? '6–8' : fin <= 92 ? '8' : fin <= 104 ? '8–10' : fin <= 116 ? '10' : '10–12');
    }
    set(size, !o.leaves && shape === 'round' ? o.width + '″ round' : o.width + '″ × ' + fin + '″' + (o.leaves ? ' extended' : ''));
    set(cap, seats ? 'Comfortably seats approximately ' + seats.replace(/-/g, '–') : 'Seating estimate unavailable for this configuration.');
  }
  function target() {
    var inline = document.querySelector('[id^="OafSeatingGuide"]');
    if (inline) {
      var o = read();
      if (!o.sized || o.hasLength || !o.hasWidth) return null; /* inline guide handles Width + Length tables */
      var mx = []; try { mx = JSON.parse(inline.dataset.seating || '[]'); } catch (e) {}
      return {el: inline, matrix: mx};
    }
    var marker = document.querySelector('[data-oaf-table-product]');
    if (!marker) return null;
    if (marker.classList.contains('oaf-seating-guide') && !marker.dataset.oafFallback) return null; /* configured in oaf-table-guides.js */
    if (!read().sized) return null;
    if (!marker.dataset.oafFallback) {
      marker.dataset.oafFallback = '1';
      marker.className = 'oaf-seating-guide';
      marker.innerHTML = '<div class="oaf-seating-guide__eyebrow">TABLE SIZE &amp; SEATING GUIDE</div><div class="oaf-seating-guide__result"><strong class="oaf-seating-guide__size">Select your table size</strong><span class="oaf-seating-guide__capacity">Your finished size and seating estimate will update as you choose options.</span></div><div class="oaf-seating-guide__note">Approximate comfortable seating. Chair width, table base and top shape can affect capacity.</div>';
    }
    return {el: marker, matrix: []};
  }
  var busy = false;
  function update() {
    if (busy) return; busy = true;
    try { var t = target(); if (t) compute(t.el, t.matrix); } finally { busy = false; }
  }
  function later() { setTimeout(update, 120); }
  var bound = null;
  function bind() {
    var r = root();
    if (r && r !== bound) { bound = r; r.addEventListener('change', later); r.addEventListener('click', later); }
    later();
  }
  function start() {
    bind();
    var mo = new MutationObserver(function () { bind(); });
    mo.observe(document.body, {childList: true, subtree: true, characterData: true});
    setTimeout(function () { mo.disconnect(); setInterval(update, 1500); }, 30000);
    [400, 1200, 2500, 5000].forEach(function (d) { setTimeout(update, d); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
